import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery, useQueryClient } from '@tanstack/react-query';
import getFetchShipOfferingsOptions from './get-options';

/**
 * Fetches shipping availability for a sku by country at minimum and by postal code if available. This hook will handle the Shipping estimate preview for each item in the cart.
 * @param {Object} param
 * @param {string} param.skuId - Sku identifier, unique UUID of the sku
 * @param {string} param.productId - Product identifier
 * @param {string} param.postalCode - Postal code for the shipping estimate
 * @param {Function} param.select - Optional selector function to transform the data
 * @returns {Object} - useQuery object
 */

var useFetchShipOfferings = function useFetchShipOfferings(_ref) {
  var skuId = _ref.skuId,
    productId = _ref.productId,
    postalCode = _ref.postalCode,
    select = _ref.select,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var queryClient = useQueryClient();
  return useQuery(_objectSpread(_objectSpread(_objectSpread({}, getFetchShipOfferingsOptions({
    skuId: skuId,
    productId: productId,
    postalCode: postalCode,
    queryClient: queryClient
  })), select && {
    select: select
  }), {}, {
    enabled: Boolean(skuId || productId) && enabled
  }));
};
export default useFetchShipOfferings;